import { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  children?: ReactNode;
  className?: string;
}

const PageHeader = ({ title, children, className = '' }: PageHeaderProps) => (
  <header className={`page-header ${className}`.trim()}>
    <h1 className="page-header__title">{title}</h1>
    {children ? <div className="page-header__actions">{children}</div> : null}
  </header>
);

export default PageHeader;
